<script>
  export default {
    name: 'data-path',
    data () {
      return {
        imagePath: '/static/image/works/',
        videoPath: '/static/video/works/'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/DataPath.vue